import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useUser } from '@tyro/api';
import { Avatar } from '@tyro/core/avatar';
import { useSaveBarPresence } from '@tyro/core/save-bar';
import type { NavigationConfig } from '../../../hooks/use-navigation-config';
import { Logo } from '../../logo';
import { NAV } from './config';
import { ExpandButton } from './expanding-button';
import { NavSectionMini } from './nav-section';

interface NavMiniProps {
  onExpand: VoidFunction;
  navConfig: NavigationConfig;
}

export default function NavMini({ onExpand, navConfig }: NavMiniProps) {
  const { activeProfile } = useUser();
  const { saveBarHeight } = useSaveBarPresence();

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD_MINI },
        zIndex: 'drawer',
      }}
    >
      <ExpandButton isExpanded={false} onClick={onExpand} />
      <Stack
        sx={{
          pb: saveBarHeight > 0 ? `${saveBarHeight + 12}px` : 0,
          height: 1,
          position: 'fixed',
          width: NAV.W_DASHBOARD_MINI,
          borderRight: (theme) => `solid 1px ${theme.palette.divider}`,
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
          overflowX: 'scroll',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        {activeProfile?.tenant?.imgUrl ? (
          <Avatar
            name={activeProfile.tenant?.name}
            src={activeProfile.tenant.imgUrl}
            size={50}
            sx={{
              mx: 'auto',
              my: 2.5,
            }}
          />
        ) : (
          <Logo sx={{ mx: 'auto', my: 2, width: 50, height: 58 }} />
        )}

        <NavSectionMini data={navConfig} />
      </Stack>
    </Box>
  );
}
